import {hasFlag} from "@2d-front-monorepo/core";
import React, {JSX, memo} from "react";
import {residencyToCompactString} from "../helpers/residencyToCompactString";
import RequiredResidencyProperties from "../installations/RequiredResidencyProperties";
import {ResidencyResult} from "../types/ResidencyResult";

//https://schema.org/PostalAddress
function AddressComponent({value, hiddenEntityProperties}: { value: ResidencyResult, hiddenEntityProperties: RequiredResidencyProperties }): JSX.Element {
	const address = value.address;
	const sa = residencyToCompactString(value);

	return (
		<div translate="no" vocab="https://schema.org/" typeof="PostalAddress" className="residency-view">
			<span property="streetAddress">{sa}</span>
			<br/>
			{!hasFlag(hiddenEntityProperties, RequiredResidencyProperties.City) && address.city ? <span property="addressLocality">{address.city}, </span> : null}
			{!hasFlag(hiddenEntityProperties, RequiredResidencyProperties.State) && address.state ? <span property="addressRegion">{address.state} </span> : null}
			{!hasFlag(hiddenEntityProperties, RequiredResidencyProperties.PostalCode) && address.postalCode ? <span property="postalCode">{address.postalCode}</span> : null}
			{/*<abbr property="addressCountry">USA</abbr>*/}
		</div>
	);
}

const MemoizedAddressComponent: React.FC<{ value: ResidencyResult, hiddenEntityProperties: RequiredResidencyProperties }> = memo(AddressComponent);
export default MemoizedAddressComponent;
